import { Component, Input, OnInit } from "@angular/core";

import { PropertiesService } from '@core/services/properties.service';
import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

@Component({
  selector: 'app-plugin-information-modal',
  templateUrl: './plugin-information-modal.component.html'
})
export class PluginInformationModalComponent implements OnInit {

  @Input() addOn: Addon.AddonModel;
  @Input() activeUser: ActiveUser.ActiveUserModel;
  @Input() loading: boolean;
  @Input() licenseFreeAddons: any;
  availableAddons: any;

  constructor(private customEventService: CustomEventService,
              public propertiesService: PropertiesService) { }

  ngOnInit(): void {
    this.availableAddons = this.licenseFreeAddons?.includes(this.addOn.name);
  }

  install(): void {
    if (this.propertiesService.PLAYGROUND || (this.activeUser.limitedEdition && !this.addOn.free)) {
      return;
    }
    this.customEventService.announceEvent(ActionTypesEnum.INSTALL_ADDON, this.addOn);
  }
}
